import { fontIconString } from "./fontIconString.js";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { DetermineTextColor } from "./DetermineTextColor.js";
import { enumButtonLabelPosition } from "../constants";
import { QFramelessPanelButton } from "../CoreApp/QFramelessPanelButton.js";

export function AddFramelessButton(parent, label, cmdCode, x, y) {
  var newButton = new QFramelessPanelButton();
  newButton.SetLabel(label);
  newButton.SetCmdCode(cmdCode);
  newButton.SizeElement(20, 22);
  newButton.PositionElement(x, y);
  newButton.fFontString = fontIconString(17, "400");
  newButton.fTxtFillStyle = DetermineTextColor(uFramelessPanelColor);
  newButton.fLabelPosition = enumButtonLabelPosition.center;
  newButton.SetShownState(true);
  newButton.SetShowLabel(true);
  parent.PushElement(newButton);
  return newButton;
}
